module.exports = {
  "name": "flat",
  "processSafe": true,
  "regExp": /^\*flat\*/,
  "parserFunc": function parser_flat (params) {
     var key = this.getHeadStr();
     var val = params.item;
     params.resultRow[key] = val;
  }
};



//////////////////
// WEBPACK FOOTER
// ./~/csvtojson/libs/core/defaultParsers/parser_flat.js
// module id = 804
// module chunks = 0